import React, { useState, useEffect } from 'react';
import ApiService from '../../services/apiService';
import { toast } from 'react-toastify';

const ItemUpdateGridPurchaseReturn = ({ onRequisitionData, GrnItemData, item, SelectedPO, currencyPrecision }) => {
    const apiService = new ApiService();
    const [rows, setRows] = useState([{
        requisitionNo: '',
        srno: '',
        recordId: '',
        ItemNo: '',
        itemDescription: '',
        specification: '',
        balqty: '',
        uom: '',
        baseQty: '',
        baseAmount: '',
        amount: '',
        discount: '',
        vat: '',
        vatAmount: '',
        vatDec: '',
        conValue: '',
        expDate: '',
    }]);
    useEffect(() => {
        getItems();
    }, [GrnItemData]);
    const getItems = async () => {
        try {
            const formattedRowsitm = GrnItemData?.map(async (detail, index) => {
                const selecteditmstock = await apiService.getApiParamater('GET_ITEM', `?Warehouse=${SelectedPO?.value?.warehouse}&ItemNo=${detail?.itemCode}`);
                let item = selecteditmstock?.data?.result?.[0]
                let selectedPO = SelectedPO?.value;
                let selecteditms = selectedPO?.grnDetails?.find(itm => itm.itemCode === detail.itemCode);

                return {
                    srno: detail?.srno,
                    ItemNo: detail.itemCode,
                    itemDescription: detail.itemDescription,
                    balqty: detail.balQty,
                    stock: (detail.qty * item.convToInvUOM)?.toFixed(2),
                    qty: detail.qty,
                    stockloc: item?.stock / item.convToInvUOM,
                    conValue: item.convToInvUOM,
                    uom: detail.uom,
                    baseAmount: detail.amount,
                    specification: detail.specification,
                    unitPrice: detail.unitPrice,
                    amount: 0,
                    vat: detail.vatPerc || 0,
                    vatAmount: detail.vatAmount,
                    vatDec: detail?.vatDesc,
                    grnDetailId: selecteditms?.grnDetailId,
                };
            }).filter(row => row !== null);
            const formattedRows = await Promise.all(formattedRowsitm);
            if (formattedRows.length > 0) {
                setRows(formattedRows || [{
                    requisitionNo: '',
                    srno: '',
                    recordId: '',
                    ItemNo: '',
                    itemDescription: '',
                    specification: '',
                    balqty: '',
                    uom: '',
                    baseQty: '',
                    baseAmount: '',
                    amount: '',
                    discount: '',
                    vat: '',
                    vatAmount: '',
                    vatDec: '',
                    conValue: '',
                    expDate: '',
                }]);
                onRequisitionData(formattedRows || [{
                    requisitionNo: '',
                    srno: '',
                    recordId: '',
                    ItemNo: '',
                    itemDescription: '',
                    specification: '',
                    balqty: '',
                    uom: '',
                    baseQty: '',
                    baseAmount: '',
                    amount: '',
                    discount: '',
                    vat: '',
                    vatAmount: '',
                    vatDec: '',
                    conValue: '',
                    expDate: '',
                }]);
            } else {
                setRows([{
                    requisitionNo: '',
                    srno: '',
                    recordId: '',
                    ItemNo: '',
                    itemDescription: '',
                    specification: '',
                    balqty: '',
                    uom: '',
                    baseQty: '',
                    baseAmount: '',
                    amount: '',
                    discount: '',
                    vat: '',
                    vatAmount: '',
                    vatDec: '',
                    conValue: '',
                    expDate: '',
                }]);
                onRequisitionData([{
                    requisitionNo: '',
                    srno: '',
                    recordId: '',
                    ItemNo: '',
                    itemDescription: '',
                    specification: '',
                    balqty: '',
                    uom: '',
                    baseQty: '',
                    baseAmount: '',
                    amount: '',
                    discount: '',
                    vat: '',
                    vatAmount: '',
                    vatDec: '',
                    conValue: '',
                    expDate: '',
                }]);

            }
        } catch (error) {
            console.error('Error fetching items:', error);

            setRows([{
                requisitionNo: '',
                srno: '',
                recordId: '',
                ItemNo: '',
                itemDescription: '',
                specification: '',
                balqty: '',
                uom: '',
                baseQty: '',
                baseAmount: '',
                amount: '',
                discount: '',
                vat: '',
                vatAmount: '',
                vatDec: '',
                conValue: '',
                expDate: '',
            }]);
            onRequisitionData([{
                requisitionNo: '',
                srno: '',
                recordId: '',
                ItemNo: '',
                itemDescription: '',
                specification: '',
                balqty: '',
                uom: '',
                baseQty: '',
                baseAmount: '',
                amount: '',
                discount: '',
                vat: '',
                vatAmount: '',
                vatDec: '',
                conValue: '',
                expDate: '',
            }]);
        }
    }
    const handleQtyChange = (index, value) => {
        const newQty = parseInt(value) || '';
        const balQty = rows[index].balqty;
        const stock = rows[index].stockloc;
        const unitPrice = rows[index].unitPrice;
        const vatPerc = rows[index].vat;
        const convToInvUOM = rows[index].conValue;
        const item = rows[index].itemDescription;

        if (newQty < 0) {
            toast.warning('Quantity cannot be less than 0.');
            return;
        } else if (stock === 0) {
            toast.warning('Stock not available in this Location');
            return
        } else if (newQty > stock) {
            toast.warning('Enter a quantity less than or equal to the Stock');
            return
        } else if (newQty > balQty) {
            toast.warning('Enter a quantity less than or equal to the balance quantity.');
            return
        } else {
            const amountBeforeVat = newQty * unitPrice;
            const vatAmount = (amountBeforeVat * vatPerc) / 100;

            let totalAmount;
            if (SelectedPO?.value.vatInclusive === true) {
                totalAmount = amountBeforeVat;
            } else {
                totalAmount = amountBeforeVat + vatAmount;
            }
            setRows(prevRows => {
                const newRows = [...prevRows];
                newRows[index].qty = newQty;
                newRows[index].stock = newQty * convToInvUOM || 0;
                newRows[index].amount = totalAmount;
                newRows[index].vatAmount = vatAmount;
                return newRows;
            });
        }
    }
    const handleDateChange = (index, expDate) => {
        const updatedRows = [...rows];
        updatedRows[index].expDate = expDate;
        const updatedSelectedRows = rows.map((row, i) =>
            i === index ? { ...row, expDate: expDate } : row
        );
        setRows(updatedSelectedRows);
        onRequisitionData(updatedSelectedRows);
    }
    const preventNegativeSign = (e) => {
        if (e.key === "-" || e.key === "+") {
            e.preventDefault();
        }
    }
    return (
        <div>
            <div className='table-container p-1' style={{ overflowX: 'auto', height: "400px" }}>
                <table>
                    <thead className='dynoTable' >
                        <tr>
                            <th>Sr no</th>
                            <th>Item No</th>
                            <th>Description</th>
                            <th>Item Specs</th>
                            <th>Qty</th>
                            <th>Packing UOM</th>
                            <th>Inventory Qty</th>
                            <th>Bal Qty</th>
                            <th>Stock</th>
                            <th>Unit Price</th>
                            <th>Discount</th>
                            <th>VAT %</th>
                            <th>VAT Amount</th>
                            <th>Amount</th>
                            <th>Exp Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows?.map((row, index) => (
                            <tr key={index}>
                                <td className='m-0 p-0'><input className='p-2' type="text" value={index + 1} disabled style={{ width: "100px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.ItemNo} style={{ width: "120px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.itemDescription} style={{ width: "150px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.specification} style={{ width: "120px" }} /></td>
                                <td className='m-0 p-0'>
                                    <input disabled={item?.eye === true ? true : false}
                                        className='p-2' style={{ width: "100px" }}
                                        type="number" onWheel={(e) => e.target.blur()}
                                        value={row.qty}
                                        max={row.balqty} onKeyDown={preventNegativeSign}
                                        onChange={(e) => handleQtyChange(index, e.target.value)}
                                    />
                                </td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.uom} style={{ width: "140px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.stock || 0} style={{ width: "140px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.balqty || 0} style={{ width: "100px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={row.stockloc || 0} style={{ width: "100px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={Number(row?.unitPrice || 0).toFixed(currencyPrecision || 0)} style={{ width: "100px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' value={row.discount} disabled style={{ width: "100px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' value={row.vat} disabled style={{ width: "100px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' value={Number(row?.vatAmount || 0).toFixed(currencyPrecision || 0)} disabled style={{ width: "120px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' disabled value={Number(row?.amount || 0).toFixed(currencyPrecision || 0)} style={{ width: "100px" }} /></td>
                                <td className='m-0 p-0'><input className='p-2' type='date' value={row?.expDate} disabled={item?.eye === true ? true : false}
                                    onChange={(e) => handleDateChange(index, e.target.value)} style={{ width: "130px" }} /></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ItemUpdateGridPurchaseReturn;
